﻿import onReady from '../utils/onReady';
import * as ClassList from '../utils/classList';
import domIterator from '../utils/domIterator';
import triggerCustomEvent from '../utils/triggerCustomEvent';
import onWindowResize from '../utils/responsiveWindow';
import queryStringParam from '../utils/queryStringParam';


/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class Filter {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        
        //show filter on init
        ClassList.add(this.dom.filterSettings, "filter__settings--active");
        // Remove hidden state so that the screenreader can use the content
        this.dom.filterStatesWrapper.hidden = false;
        let maxHeight = this.dom.filterSettings.scrollHeight;
        this.dom.filterSettings.style.maxHeight = `${maxHeight}px`;





    }

    addEvents() {
        this.dom.buttonToggle.addEventListener("click", e => {
            this.toggle(e);
        });

        this.dom.buttonReset.addEventListener("click", () => {
            this.reset();
        });

        this.dom.buttonSubmit.addEventListener("click", e => {
            e.preventDefault();
            this.submit();
        });

        domIterator(this.dom.apartmentLinks, element => {
            element.addEventListener("click", e => {
                e.preventDefault();
                this.sendCheckedLeasetype(element);
            });
        });

        // Add hidden state, when css transition has ended so that the screenreader don't have to crawl the content
        this.dom.filterSettings.addEventListener( "transitionend", () => {
			if (this.dom.buttonToggle.getAttribute('aria-expanded') === 'false') {
				this.dom.filterStatesWrapper.hidden = true;
			}
        });

        onWindowResize( () => this.resizeHasHappened());
    }

    /**
     * Adds parameters to url, so section page knows which checkboxes to check
     *
     * @param {HTMLElement} link - the clicked anchor tag
     */
    sendCheckedLeasetype(link) {
        let checkboxes = link.closest(".row").querySelectorAll("input[type='checkbox']"),
            url = link.getAttribute("href");

        domIterator(checkboxes, element => {
            if (element.checked) {
                let leaseType = element.dataset.leaseType;
                url += "&" + leaseType;
            }
        });

        window.location.href = url;
    }

    /**
     * Makes sure that max-height is not stuck at fx. 800px, when resizing to mobile, the max-height might need to be 1200px
     *
     */
    resizeHasHappened() {
        let maxHeight = this.dom.filterSettings.scrollHeight,
            curHeight = this.dom.filterSettings.clientHeight;

        if (maxHeight > curHeight && ClassList.contains(this.dom.filterSettings, "filter__settings--active")) {
            this.dom.filterSettings.style.maxHeight = `${maxHeight}px`;
        }
    }

    removePossibleInjectionThreads(inputString) {
        if (inputString)
        {
            inputString = inputString.length > 150 ? inputString.toLowerCase().substr(0, 150) : inputString.toLowerCase();

            inputString = inputString.toLowerCase().replace(/[<>=;,\.()]+/gi, "");
            //inputString = inputString.replace(">", "");
            //inputString = inputString.replace("&gt;", "");
            //inputString = inputString.replace("&lt;", "");
            //inputString = inputString.replace("<", "");
            //inputString = inputString.replace("=", "");
            //inputString = inputString.replace(".", "");
            //inputString = inputString.replace(";", "");
            //inputString = inputString.replace("(", "");
            //inputString = inputString.replace(")", "");

            return inputString;

        }

        return "";
    }

    /**
     * Open and close the filter container
     *
     */
    toggle(e) {
        e.preventDefault();

        // Check and set toggle button expanded state
        let expanded = this.dom.buttonToggle.getAttribute('aria-expanded') === 'true' || false;
        this.dom.buttonToggle.setAttribute('aria-expanded', !expanded);

        if (ClassList.contains(this.dom.filterSettings, "filter__settings--active")) {
            ClassList.remove(this.dom.filterSettings, "filter__settings--active");
            this.dom.filterSettings.style.maxHeight = "24px";
        } else {
            ClassList.add(this.dom.filterSettings, "filter__settings--active");
            // Remove hidden state so that the screenreader can use the content
            this.dom.filterStatesWrapper.hidden = false;
            let maxHeight = this.dom.filterSettings.scrollHeight;
            this.dom.filterSettings.style.maxHeight = `${maxHeight}px`;

            if (!this.filtersApplied) {
                this.applyFilterValues();
                this.filtersApplied = 1;
            }
        }
    }

    /**
     * Resets filter values to default
     *
     */
    reset() {
        this.dom.container.reset();
        domIterator(this.dom.rangeSliders, element => {
            triggerCustomEvent(element, 'slider-reset');
        });

    }

    /**
     * Applies text value from querystring to input field
     *
     */
    applyTextValue() {
        if (!this.dom.mainSearch.value.length) {
            this.dom.mainSearch.value = this.removePossibleInjectionThreads( queryStringParam("searchText", this.settings.fullUrl) );
        }
    }

    /**
     * Called on opening of filters, to make sure filter sliders are initialized before calling
     *
     */
    applyFilterValues() {

        // If there is no query string besides searchText, return
        if (!/&/.test(window.location.href)) {
            return;
        }

        let sliderNames = [
            "rooms",
            "area",
            "rent"
        ];

        sliderNames.forEach((element, index) => {
            triggerCustomEvent(this.dom.rangeSliders[index], "slider-set", {min: queryStringParam(element + "Min", this.settings.fullUrl), max: queryStringParam(element + "Max", this.settings.fullUrl)});
        });
    }

    /**
     * Check checkboxes if they are in querystring
     *
     */
    applyCheckboxValues() {
        for (let key in this.checkboxes) {
            if (this.checkboxes.hasOwnProperty(key)) {

                // Check if key is in query string
                if (queryStringParam(key, this.settings.fullUrl)) {
                    this.checkboxes[key].checked = true;
                    this.checkboxes[key].checked = "checked";

                    if (this.listCheckboxes.hasOwnProperty(key)) {

                        domIterator(this.listCheckboxes[key], element => {

                            if (!element.disabled) {
                                element.checked = true;
                                element.checked = "checked";
                            }

                        });
                    }
                } else {
                    this.checkboxes[key].checked = false;

                    if (this.listCheckboxes.hasOwnProperty(key)) {
                        domIterator(this.listCheckboxes[key], element => {
                            element.checked = false;
                        });
                    }
                }
            }
        }
    }


    /**
     * Set the correct radiobutton from querystring data
     *
     */
    applyRadioValues() {
        // Find which radio is checked
        let checkedRadio = (queryStringParam("availability", this.settings.fullUrl));

        // If checkedRadio is not null, set radio's
        if (checkedRadio) {
            this.radios[checkedRadio].checked = true;
        }
    }


    /**
     * Calls functions that sets values
     *
     * @return {} Returns if no querystring is present
     */
    applyValues() {
        this.applyTextValue();

        // If there is no query string besides searchText, return
        if (!/&/.test(window.location.href)) {
            return;
        }

        this.applyCheckboxValues();
        this.applyRadioValues();
    }

    submit() {

        // Trigger custom event, because .submit() doesn't trigger submit event
        triggerCustomEvent(this.dom.container, "submit");
        this.dom.container.submit();
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        this.settings = {
            url: window.location.protocol + "//" + window.location.hostname + window.location.pathname,
            fullUrl: window.location.href,
            queryString: ""
        };

        this.dom.container.action = this.settings.url;
        this.dom.container.method = "get";

        // Put your other DOM-specific initializations here, and get your class moving!

        this.dom.rangeSliders = this.dom.container.querySelectorAll(".filter__slider");
        this.dom.filterSettings = this.dom.container.querySelector(".filter__settings");
        this.dom.filterStatesWrapper = this.dom.container.querySelector(".filter__states-wrapper");
        this.dom.buttonToggle = this.dom.container.querySelector(".filter__toggle");
        this.dom.buttonReset = this.dom.container.querySelector(".filter__reset");
        this.dom.buttonSubmit = this.dom.container.querySelector(".buttonSubmit");
        this.dom.mainSearch = this.dom.container.querySelector(".main-search input");


        this.checkboxes = {
            homeFamily: this.dom.container.querySelector("#homeFamily"),
            homeYouth: this.dom.container.querySelector("#homeYouth"),
            homeElder: this.dom.container.querySelector("#homeElder"),
            homeCoOwner: this.dom.container.querySelector("#homeCoOwner"),
            animalAllow: this.dom.container.querySelector("#animalAllow"),
            lift: this.dom.container.querySelector("#lift"),
            balcony: this.dom.container.querySelector("#balcony")
        };

        this.radios = {
            all: this.dom.container.querySelector("#availabilityAll"),
            available: this.dom.container.querySelector("#availabilityAvailable"),
            wait: this.dom.container.querySelector("#availabilityWait")
        };

        this.listCheckboxes = {
            homeFamily: document.querySelectorAll(".listHomeFamily"),
            homeYouth: document.querySelectorAll(".listHomeYouth"),
            homeElder: document.querySelectorAll(".listHomeElder"),
            homeCoOwner: document.querySelectorAll(".listHomeCoOwner")
        };

        this.dom.apartmentLinks = document.querySelectorAll(".apartment-link");

        this.filtersApplied = 0;

        this.applyValues();
        this.addEvents();
    }
}


export default Filter;
